import workspace from "../workspace";
import {getBacksplashesPos, getBumpoutPointCords, getShapePosAndPoints} from "./slabHelper";
import sqftShapeManager from "../../store/sqftShapeManager";
import {SHAPE_PART_ID, WATERFALL_SHAPES_KEY} from "../../../../constants";
import SlabAdditionalShape from "./slabAdditionalShape";
import Polygon from "../shapes/layouts/polygon";
import sqftConfig from "../../store/sqftConfig";
import {getParallelPoints, getPointOnTheLine, mmToInches} from "../../../../helpers/sqftHelper";
import {addEdgeToTheLines, addFakeEdgeToLines, setLineParams} from "../../helpers/lineHelper";
import workspaceControllers from "../../store/workspaceControllers";
import {getMiterEdgeFeature, isFeatureUnitUseEach} from "../../../../helpers/featureHelper";
import config from "../../store/sqftConfig";

class SlabAdditionalShapes {
  additionalShapes = [];

  initBacksplashAndEdgeShapes = () => {
    let lines = workspace.getLines();
    lines.forEach((line) => {
      if (!this.isInited(line)) {
        let posOnField, pointsCords;
        const parentShape = line.getParent();

        // 1.) init backsplash shapes
        if (line.isWithBacksplash()) {
          [posOnField, pointsCords] = getBacksplashesPos(line, +line.getBacksplashHeight());

        // 2.) init mitered edgeShapes for waterfall tool
        } else if ((line.isWithMiterEdge() || line.isWithFakeEdge())
          && parentShape.partId === SHAPE_PART_ID.waterfallPiece
        ) {
          // skip creation for one mitered edge shape that was created with waterfall tool
          if (line.getState().slabModeSkipMiteredEdgeCreation) {
            return;
          }
          const segment = workspaceControllers.waterfall.getSegmentById(parentShape.slabModeWaterfallSegmentId);
          if (!segment) {
            //todo fix missing segment
            return;
          }
          [posOnField, pointsCords] = getBacksplashesPos(line, segment.thickness);
        // 3.) init mitered edgeShapes but skip mitered tool
        } else if (line.isWithMiterEdge() && !line.isWithMitered()) {
          [posOnField, pointsCords] = getBacksplashesPos(line, sqftConfig.miteredEdgeAdditionalImperialArea);

        // 4.) init waterfall edgeShapes but skip mitered tool
        } else if (line.isWithWaterfallEdgeFeature() && !isFeatureUnitUseEach(line.getAttachedFeature())) {
          [posOnField, pointsCords] = getBacksplashesPos(line, sqftConfig.waterfallImperialHeight);
        } else {
          return; // Skip the current iteration if neither condition is met
        }

        // create shape
        let shapeId = sqftShapeManager.addShape(new Polygon(pointsCords), 'square', posOnField, SHAPE_PART_ID.backsplashPiece);
        const shape = workspace.getShapeById(shapeId);

        // set shape additional params
        shape.setIsPointsChanged(false);
        shape.setSlabModeCoreParentId(
          line.getParent().slabModeCoreParentId ? line.getParent().slabModeCoreParentId : line.getParent().id
        );
        shape.setSlabModeCoreParentPartId(
          line.getParent().slabParentPartId ? line.getParent().slabParentPartId : line.getParent().partId
        )
        //set shape feature id
        let featureId
        if (line.isWithBacksplash()) {
          featureId = line.getBacksplashFeatureId();
          featureId = featureId ? featureId : line.getParent().featureId;
        } else {
          featureId = line.getParent().featureId;
        }
        shape.setFeatureId(featureId);
        shape.setColorSet(line.getParent().colorSet);

        this.addActiveBacksplash(new SlabAdditionalShape(line, shapeId));
      }
    });
  };

  initBumpoutShapes = () => {
    let lines = workspace.getLines();
    lines.forEach((line) => {
      if (line.isWithBumpout() && !this.isInited(line)) {
        let pointsCords = getBumpoutPointCords(line);
        let posOnFiled = line.getParent().getPosition();//ShapeHelper.getCenterPoint(pointsCords);
        let shapeId = sqftShapeManager.addShape(new Polygon(pointsCords), 'square', posOnFiled, SHAPE_PART_ID.backsplashPiece);
        const shape = workspace.getShapeById(shapeId);
        shape.setIsPointsChanged(false);
        shape.setFeatureId(line.getParent().featureId);
        shape.setSlabModeCoreParentId(line.getParent().id);
        shape.setSlabModeCoreParentPartId(line.getParent().partId);
        shape.setColorSet(line.getParent().colorSet);

        this.addActiveBacksplash(new SlabAdditionalShape(line, shapeId));
      }
    });
  };

  initMiteredToolShapes = () => {
    let lines = workspace.getLines();
    lines.forEach((line) => {
      if (line.isWithMitered() && !this.isInited(line)) {
        const miteredPoints = line.miteredOverlay.getPoints();
        miteredPoints.forEach((point, index) => {
          let next = index + 1;
          if (miteredPoints[next]) {
            let segment = line.miteredOverlay.getSegmentBetweenPoints(point, miteredPoints[next]);
            //let widthValue = segment.width.value;
            let heightValue = segment.height / sqftConfig.getMeasureMultiplier();
            let [posOnFiled, pointsCords] = getShapePosAndPoints(line.getParent(), point, miteredPoints[next], heightValue);

            let shapeId = sqftShapeManager.addShape(new Polygon(pointsCords), 'square', posOnFiled, SHAPE_PART_ID.backsplashPiece);
            const shape = workspace.getShapeById(shapeId);
            shape.setIsPointsChanged(false);
            shape.setFeatureId(line.getParent().featureId);
            shape.setSlabModeCoreParentId(line.getParent().id);
            shape.setSlabModeCoreParentPartId(line.getParent().partId);
            shape.setColorSet(line.getParent().colorSet);

            this.addActiveBacksplash(new SlabAdditionalShape(line, shapeId));
          }
        });
      }
    });
  };

  initUnderlaymentToolShapes = () => {
    let lines = workspace.getLines();
    lines.forEach((line) => {
      if (line.isWithUnderlayment() && !this.isInited(line)) {
        const underlaymentPoints = line.underlaymentOverlay.getPoints();
        underlaymentPoints.forEach((point, index) => {
          let next = index + 1;
          if (underlaymentPoints[next]) {
            let segment = line.underlaymentOverlay.getSegmentBetweenPoints(point, underlaymentPoints[next]);
            //let widthValue = segment.width.value;
            let heightValue = segment.height;
            let [posOnFiled, pointsCords] = getShapePosAndPoints(line.getParent(), point, underlaymentPoints[next], heightValue);

            let shapeId = sqftShapeManager.addShape(new Polygon(pointsCords), 'square', posOnFiled, SHAPE_PART_ID.backsplashPiece);
            const shape = workspace.getShapeById(shapeId);
            shape.setIsPointsChanged(false);
            shape.setFeatureId(line.getParent().featureId);
            shape.setSlabModeCoreParentId(line.getParent().id);
            shape.setSlabModeCoreParentPartId(line.getParent().partId);
            shape.setColorSet(line.getParent().colorSet);

            this.addActiveBacksplash(new SlabAdditionalShape(line, shapeId));
          }
        });
      }
    });
  };

  initWaterfallToolShapes = () => {
    let lines = workspace.getLines();
    lines.forEach((line) => {
      if ((line.isWithWaterfallToolEdge() || line.isWithPeninsulaUnderwrapEdge())
        && !this.isInited(line)
      ) {
        const waterfallSegments = line.waterfallOverlay.getSegments();

        waterfallSegments.forEach((segment) => {
          const [from, to] = this.getWaterfallPoints(line, segment);
          if (from && to) {
            const height =  config.measureUnit === "Imperial" ? segment.height : mmToInches(segment.height);
            let [posOnFiled, pointsCords] = getShapePosAndPoints(line.getParent(), from, to, height);

            let shapeId = sqftShapeManager.addShape(new Polygon(pointsCords.reverse()), 'square', posOnFiled, SHAPE_PART_ID.waterfallPiece);
            const shape = workspace.getShapeById(shapeId);
            shape.setIsPointsChanged(false);
            shape.setFeatureId(line.getParent().featureId);
            shape.setColorSet(line.getParent().colorSet);
            shape.setSlabModeCoreParentId(line.getParent().id);
            shape.setSlabModeCoreParentPartId(line.getParent().partId);
            shape.setSlabModeWaterfallSegmentId(segment.id);

            this.addMiteredEdgesToWaterfallShape(shapeId, segment);

            this.addActiveBacksplash(new SlabAdditionalShape(line, shapeId));

          }
        });
      }
    });
  };

  addMiteredEdgesToWaterfallShape = (shapeId, segment) => {
    const miteredEdge = getMiterEdgeFeature();

    const waterfallShapes = WATERFALL_SHAPES_KEY;
    const edgeParams = {
      [waterfallShapes.cabinetReturn]: [3],
      [waterfallShapes.waterfall]: [1, 2, 3],
      [waterfallShapes.overhangReturn]: [1],
      [waterfallShapes.underlayment]: [0]
    };
    if (edgeParams[segment.name]) {
      if (miteredEdge) {
        addEdgeToTheLines(shapeId, miteredEdge, edgeParams[segment.name], false);
      } else {
        addFakeEdgeToLines(shapeId, edgeParams[segment.name]);
      }
    }

    if (segment.name === waterfallShapes.waterfall) {
      setLineParams(shapeId, [1, 2, 3], { slabModeSkipMiteredEdgeCreation: true });
    }
  };

  getWaterfallPoints = (line, segment) => {
    const key = segment.key;
    const length = config.measureUnit === "Imperial" ? segment.length : mmToInches(segment.length);
    if (segment.isDisabled) {
      return [null, null]
    }
    switch (key) {
      case WATERFALL_SHAPES_KEY.cabinetReturn: {
        const secondPoint = getPointOnTheLine(line.to, line.from, -length);
        return [secondPoint, line.to]
      }
      case WATERFALL_SHAPES_KEY.waterfall: {
        const distanceFromLine = -segment.height * 2 / sqftConfig.getMeasureMultiplier();
        const [firstPoint, secondPoint] = getParallelPoints(line.from, line.to, distanceFromLine);
        return [firstPoint, secondPoint]
      }
      case WATERFALL_SHAPES_KEY.overhangReturn: {
        const secondPoint = getPointOnTheLine(line.from, line.to, -length);
        return [line.from, secondPoint]
      }
      case WATERFALL_SHAPES_KEY.underlayment: {
        const nextLine = line.getParent().getNextLine(line);
        //const secondPoint = getPointOnTheLine(nextLine.to, line.from, -segment.length);
        //return [nextLine.from, nextLine.to]
        const miteredEdgeDistance = -sqftConfig.miteredEdgeAdditionalImperialArea;
        const [firstPoint, secondPoint] = getParallelPoints(nextLine.from, nextLine.to, miteredEdgeDistance);
        return [secondPoint, firstPoint]
      }
      case WATERFALL_SHAPES_KEY.peninsulaUnderwrap: {
        const [firstPoint, secondPoint] = getParallelPoints(line.from, line.to, -segment.height);
        return [firstPoint, secondPoint]
      }
      default:
        return [null, null]
    }
  }

  isInited = (line) => {
    return this.additionalShapes.some( SlabAdditionalShape => {
      return SlabAdditionalShape.line.id === line.id
    })
  }

  getShapeAdditionalShapes = (shape) => {
    return this.additionalShapes.filter( SlabAdditionalShape => {
      return SlabAdditionalShape.line.getParent().id === shape.id
    })
  }

  updateAdditionalShapeFeature = (line, featureId) => {
    const additionalShape = this.findAdditionalShapeByLine(line);
    if (additionalShape) {
      const backsplashShape = workspace.getShapeById(additionalShape.backsplashShapeId);
      backsplashShape.setFeatureId(featureId);
    }
  }

  resetBacksplashes = () => {
    this.additionalShapes = [];
  }

  importData = (data) => {
    for (let activeBacksplashData of data) {
      let shape = workspace.importShape(activeBacksplashData.backsplashShape);
      shape.deregisterEvents();
      let line = workspace.getLineById(activeBacksplashData.line.id);
      let slabAdditionalShape = new SlabAdditionalShape(line, shape.id);
      this.addActiveBacksplash(slabAdditionalShape);
    }
  }

  exportData = () => {
    return this.additionalShapes
      .filter( SlabAdditionalShape => {
        let backsplashShape = workspace.getShapeById(SlabAdditionalShape.backsplashShapeId);
        return backsplashShape.partId !== SHAPE_PART_ID.seamPiece;
      })
      .map( SlabAdditionalShape => {
      let backsplashShape = workspace.getShapeById(SlabAdditionalShape.backsplashShapeId);

      return {
        backsplashShape: backsplashShape.export(),
        line: SlabAdditionalShape.line.export()
      }
    })
  }

  addActiveBacksplash = (SlabAdditionalShape) => {
    this.additionalShapes.push(SlabAdditionalShape);
  }

  findAdditionalShapeByLine = (line) => {
    return this.additionalShapes.find(additionalShape => additionalShape.line.id === line.id);
  }

  removeActiveBacksplashByLine = (line) => {
    for (let i = this.additionalShapes.length - 1; i >= 0; i--) {
      if (this.additionalShapes[i].line.id === line.id) {
        const shape = workspace.getShapeById(this.additionalShapes[i].backsplashShapeId);
        this.removeAllActiveBacksplashesAttachedToShape(shape);
        workspace.removeShapeById(this.additionalShapes[i].backsplashShapeId);
      }
    }
  }

  findOneByBacksplashShapeId = (backsplashShapeId) => {
    return this.additionalShapes.find(activeBacksplash => {
      return activeBacksplash.backsplashShapeId === backsplashShapeId
    })
  };

  /**
   * This will hide all additional shapes that was created for mitered edges, backsplashes and mitered segments
  */
  hideAdditionalShapes = () => {
    this.additionalShapes.forEach(SlabAdditionalShape => {
      let backsplashShape = workspace.getShapeById(SlabAdditionalShape.backsplashShapeId);
      if (backsplashShape) {
        backsplashShape.deregisterEvents();
      } else {
        console.error("SlabAdditionalShape not found, backsplashShapeId:", SlabAdditionalShape.backsplashShapeId);
      }
    });
  };

  removeAllActiveBacksplashesAttachedToShape = (shape) => {
    const lines = shape.getLines();
    for (const line of lines) {
      this.removeActiveBacksplashByLine(line);
    }
  };

  restoreBacksplashShapes = () => {
    this.additionalShapes.forEach(SlabAdditionalShape => {
      let backsplashShape = workspace.getShapeById(SlabAdditionalShape.backsplashShapeId);
      if (backsplashShape.isHidden && backsplashShape.shapePieces.length === 0) {
        backsplashShape.reInitEvents();
      }
    });
  };

  removeShapeFromList = (shapeToRemove) => {
    this.additionalShapes = this.additionalShapes.filter(additionalShape => additionalShape.backsplashShapeId !== shapeToRemove.id);
  }
}

export default SlabAdditionalShapes;
